// Both halves matter. A populated `user` slice alone is not proof of a signed-in
// session: it is redux-persisted, so a slice poisoned once (e.g. by an anonymous
// getUser that resolved to the shared webshop API account) would otherwise keep
// claiming "signed in" on every later visit.
export const userIsSignedInAndLoaded = (state) => (
  state.auth.isSignedIn && state.user.id !== undefined
);
